import { jsxs as e, jsx as l } from "react/jsx-runtime";
const f = (i) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...i,
    children: [
      /* @__PURE__ */ e("g", { clipPath: "url(#stripe_svg__a)", children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#6772E5",
            d: "M18.613 0H5.387A5.387 5.387 0 0 0 0 5.387v13.226A5.387 5.387 0 0 0 5.387 24h13.226A5.387 5.387 0 0 0 24 18.613V5.387A5.387 5.387 0 0 0 18.613 0"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M11.056 9.31c0-.573.474-.83 1.239-.83a8.2 8.2 0 0 1 3.633.939v-3.4a9.6 9.6 0 0 0-3.625-.665c-2.96 0-4.938 1.546-4.938 4.156 0 4.04 5.553 3.384 5.553 5.13 0 .673-.59.889-1.396.889a9.2 9.2 0 0 1-4.04-1.189v3.483c1.26.545 2.617.828 3.99.832 3.034 0 5.13-1.497 5.13-4.157.024-4.331-5.546-3.55-5.546-5.187",
            clipRule: "evenodd"
          }
        )
      ] }),
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "stripe_svg__a", children: /* @__PURE__ */ l("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }) })
    ]
  }
);
export {
  f as default
};
